// extracted by mini-css-extract-plugin
module.exports = {"claimRow":"ClaimBoxRow_claimRow_16ktz","rowImg":"ClaimBoxRow_rowImg_2IgZ1"};